import { useWindowDimensions } from 'react-native';
import { Svg, SvgProps, Ellipse } from 'react-native-svg';

import { colors } from '../../../theme';

type Props = SvgProps;

export const HeaderBackground = ({ ...svgProps }: Props) => {
	const { width } = useWindowDimensions();

	return (
		<Svg width={width} height="90" fill="none" {...svgProps}>
			<Ellipse cx={width / 2} cy="-42" rx={width} ry="122" fill={colors.background200} />
		</Svg>
	);
};
